var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _path27, _g2, _path28, _g3, _path29, _g4, _path30, _g5, _path31, _g6, _path32, _g7, _path33, _g8, _path34, _g9, _path35, _g0, _path36, _g1, _path37, _g10, _path38, _g11, _path39, _g12, _path40, _g13, _path41, _g14, _path42, _g15, _path43, _g16, _path44, _g17, _path45, _g18, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFoundImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 674,
    height: 375,
    viewBox: "0 0 674 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M615.181 234.394C615.181 105.103 491.202 0.291992 338.265 0.291992C185.328 0.291992 61.3486 105.103 61.3486 234.394C61.3486 284.37 79.877 330.686 111.437 368.707H565.093C596.653 330.686 615.181 284.37 615.181 234.394Z",
    fill: "#FCDEDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M454.684 369.25C430.351 369.25 424.226 348.566 441.537 349.831C419.831 327.019 419.207 297.876 452.781 310.126C439.115 276.664 455.289 251.783 481.669 278.224C481.669 243.663 527.683 238.289 527.683 282.212C551.381 265.914 579.404 284.986 546.884 310.993C582.633 310.993 579.058 344.456 554.149 354.166C576.521 354.166 567.296 369.25 551.9 369.25C535.121 369.25 454.684 369.25 454.684 369.25Z",
    fill: "#536C87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M561.944 369.25C546.145 369.25 542.168 355.82 553.408 356.641C539.315 341.829 538.91 322.907 560.709 330.861C551.836 309.134 562.337 292.979 579.465 310.147C579.465 287.707 609.342 284.217 609.342 312.736C624.729 302.154 642.924 314.537 621.809 331.424C645.021 331.424 642.7 353.151 626.526 359.455C641.053 359.455 635.062 369.249 625.066 369.249C614.172 369.25 561.944 369.25 561.944 369.25Z",
    fill: "#778D9F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.317 369.25C243.649 369.25 249.774 348.566 232.463 349.831C254.169 327.019 254.793 297.876 221.219 310.126C234.885 276.664 218.711 251.783 192.331 278.224C192.331 243.663 146.318 238.289 146.318 282.212C122.619 265.914 94.5961 284.986 127.117 310.993C91.367 310.993 94.9421 344.456 119.851 354.166C97.4789 354.166 106.705 369.25 122.1 369.25C138.879 369.25 219.317 369.25 219.317 369.25Z",
    fill: "#536C87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.056 369.25C127.855 369.25 131.832 355.82 120.592 356.641C134.685 341.829 135.09 322.907 113.291 330.861C122.164 309.134 111.663 292.979 94.5342 310.147C94.5342 287.707 64.6579 284.217 64.6579 312.736C49.2706 302.154 31.0751 314.537 52.1908 331.424C28.9787 331.424 31.2999 353.151 47.4736 359.455C32.9474 359.455 38.9375 369.249 48.9337 369.249C59.8281 369.25 112.056 369.25 112.056 369.25Z",
    fill: "#778D9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M569.291 359.599H517.31C515.877 359.599 514.875 357.89 515.355 356.263L516.07 353.836L535.877 286.647C536.17 285.65 536.954 284.983 537.832 284.983H548.769C549.647 284.983 550.43 285.65 550.724 286.647L553.588 296.363L555.542 302.989L557.283 308.895L559.236 315.52L571.246 356.262C571.726 357.889 570.723 359.599 569.291 359.599Z",
    fill: "#EF5A53"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M573.274 369.249H513.326C510.338 369.249 507.916 366.821 507.916 363.827V359.258C507.916 356.264 510.338 353.836 513.326 353.836H573.274C576.262 353.836 578.684 356.264 578.684 359.258V363.827C578.684 366.821 576.262 369.249 573.274 369.249Z",
    fill: "#EF5A53"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M583.347 353.837H505.167V369.25H583.347V353.837Z",
    fill: "#EF5A53"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M555.542 302.989H531.06L533.013 296.362H553.588L555.542 302.989Z",
    fill: "#FDEEED"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M559.236 315.52H527.365L529.318 308.895H557.283L559.236 315.52Z",
    fill: "#FDEEED"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M540.552 284.983L540.165 287.576L530.271 353.836H516.07L535.878 286.646C536.171 285.649 536.954 284.983 537.833 284.983H540.552Z",
    fill: "#FCDEDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M516.07 353.837H557.805",
    stroke: "#533142",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M559.717 353.837H562.214",
    stroke: "#533142",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M538.398 287.576H548.041",
    stroke: "#533142",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M154.779 359.599H102.798C101.365 359.599 100.363 357.89 100.843 356.263L101.558 353.836L121.365 286.647C121.659 285.65 122.442 284.983 123.32 284.983H134.257C135.135 284.983 135.919 285.65 136.212 286.647L139.076 296.363L141.03 302.989L142.771 308.895L144.724 315.52L156.735 356.262C157.213 357.889 156.211 359.599 154.779 359.599Z",
    fill: "#EF5A53"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.761 369.249H98.813C95.8254 369.249 93.4033 366.821 93.4033 363.827V359.258C93.4033 356.264 95.8254 353.836 98.813 353.836H158.761C161.749 353.836 164.171 356.264 164.171 359.258V363.827C164.171 366.821 161.749 369.249 158.761 369.249Z",
    fill: "#EF5A53"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.834 353.837H90.6543V369.25H168.834V353.837Z",
    fill: "#EF5A53"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141.029 302.989H116.547L118.501 296.362H139.076L141.029 302.989Z",
    fill: "#FDEEED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.723 315.52H112.853L114.805 308.895H142.77L144.723 315.52Z",
    fill: "#FDEEED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M126.039 284.983L125.652 287.576L115.758 353.836H101.558L121.365 286.646C121.658 285.649 122.442 284.983 123.32 284.983H126.039Z",
    fill: "#FCDEDD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.558 353.837H143.292",
    stroke: "#533142",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M145.204 353.837H147.701",
    stroke: "#533142",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.886 287.576H133.529",
    stroke: "#533142",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M404.41 369.169H394.902L433.679 148.749H443.187L404.41 369.169Z",
    fill: "#533142"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M473.773 369.169H483.281L444.504 148.749H434.996L473.773 369.169Z",
    fill: "#533142"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M226.47 369.169H216.963L255.739 148.749H265.247L226.47 369.169Z",
    fill: "#533142"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M295.833 369.169H305.341L266.564 148.749H257.057L295.833 369.169Z",
    fill: "#533142"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 171,
    width: 294,
    height: 37
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "#FDEEED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 171,
    width: 294,
    height: 37
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.866 227.13L163.915 222.932L214.093 161.944L226.044 166.142L175.866 227.13Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 171,
    width: 294,
    height: 37
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.744 227.13L198.793 222.932L248.971 161.944L260.922 166.142L210.744 227.13Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 171,
    width: 294,
    height: 37
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.624 227.13L233.673 222.932L283.85 161.944L295.801 166.142L245.624 227.13Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 171,
    width: 294,
    height: 37
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.503 227.13L268.552 222.932L318.729 161.944L330.68 166.142L280.503 227.13Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 171,
    width: 294,
    height: 37
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.381 227.13L303.43 222.932L353.608 161.944L365.558 166.142L315.381 227.13Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 171,
    width: 294,
    height: 37
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.26 227.13L338.309 222.932L388.486 161.944L400.438 166.142L350.26 227.13Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 171,
    width: 294,
    height: 37
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.139 227.13L373.188 222.932L423.365 161.944L435.316 166.142L385.139 227.13Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 171,
    width: 294,
    height: 37
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.017 227.13L408.065 222.932L458.243 161.944L470.194 166.142L420.017 227.13Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 171,
    width: 294,
    height: 37
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 207.409H197.074L203.467 171.067H490.379L483.986 207.409Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.895 227.13L442.944 222.932L493.122 161.944L505.073 166.142L454.895 227.13Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 247,
    width: 294,
    height: 37
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "#FDEEED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 247,
    width: 294,
    height: 37
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.414 303.596L150.463 299.398L200.641 238.409L212.592 242.607L162.414 303.596Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 247,
    width: 294,
    height: 37
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.292 303.596L185.341 299.398L235.519 238.409L247.47 242.607L197.292 303.596Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 247,
    width: 294,
    height: 37
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.172 303.596L220.221 299.398L270.398 238.409L282.349 242.607L232.172 303.596Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 247,
    width: 294,
    height: 37
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.051 303.596L255.1 299.398L305.277 238.409L317.228 242.607L267.051 303.596Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 247,
    width: 294,
    height: 37
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.929 303.596L289.978 299.398L340.155 238.409L352.106 242.607L301.929 303.596Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 247,
    width: 294,
    height: 37
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.807 303.596L324.856 299.398L375.034 238.409L386.985 242.607L336.807 303.596Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 247,
    width: 294,
    height: 37
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.686 303.596L359.735 299.398L409.913 238.409L421.864 242.607L371.686 303.596Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 247,
    width: 294,
    height: 37
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.564 303.596L394.613 299.398L444.791 238.409L456.742 242.607L406.564 303.596Z",
    fill: "#EF5A53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_40005491_13952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 247,
    width: 294,
    height: 37
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M470.533 283.874H183.622L190.015 247.533H476.927L470.533 283.874Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_40005491_13952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.443 303.596L429.492 299.398L479.67 238.409L491.621 242.607L441.443 303.596Z",
    fill: "#EF5A53"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M271.032 141.966C271.938 136.367 268.145 131.092 262.559 130.183C256.973 129.274 251.709 133.076 250.803 138.676C249.896 144.275 253.69 149.55 259.276 150.459C264.862 151.367 270.125 147.565 271.032 141.966Z",
    fill: "#EF5A53"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M261.684 133.724C262.638 135.126 261.714 137.424 259.619 138.856C257.524 140.289 255.052 140.314 254.098 138.912C253.143 137.51 254.068 135.212 256.163 133.78C258.258 132.347 260.73 132.322 261.684 133.724Z",
    fill: "#F48C87"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M271.943 146.279H249.873V151.217H271.943V146.279Z",
    fill: "#533142"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M449.37 142.933C450.816 137.449 447.554 131.828 442.082 130.379C436.611 128.929 431.003 132.199 429.557 137.683C428.11 143.167 431.373 148.788 436.844 150.237C442.315 151.687 447.923 148.417 449.37 142.933Z",
    fill: "#EF5A53"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M440.24 133.724C441.195 135.126 440.27 137.424 438.175 138.856C436.081 140.289 433.609 140.314 432.654 138.912C431.7 137.51 432.625 135.212 434.72 133.78C436.814 132.347 439.286 132.322 440.24 133.724Z",
    fill: "#F48C87"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M450.501 146.28H428.431V151.218H450.501V146.28Z",
    fill: "#533142"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3457 369.25H668.654",
    stroke: "#533142",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M586.321 222.615C581.03 223.914 579.979 224.967 578.683 230.271C577.387 224.967 576.337 223.914 571.045 222.615C576.337 221.317 577.387 220.264 578.683 214.959C579.979 220.264 581.03 221.316 586.321 222.615Z",
    fill: "#FEFEFE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M499.76 311.645C497.081 312.303 496.549 312.836 495.893 315.521C495.237 312.835 494.705 312.303 492.026 311.645C494.705 310.988 495.237 310.454 495.893 307.77C496.549 310.454 497.081 310.988 499.76 311.645Z",
    fill: "#FEFEFE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M362.374 127.012C354.086 129.046 352.44 130.696 350.411 139.003C348.381 130.696 346.736 129.046 338.447 127.012C346.736 124.978 348.381 123.329 350.411 115.021C352.44 123.329 354.086 124.978 362.374 127.012Z",
    fill: "#FEFEFE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M105.367 69.7114C97.078 71.7457 95.4326 73.3949 93.403 81.7026C91.3734 73.3949 89.728 71.7457 81.4395 69.7114C89.728 67.6771 91.3734 66.0279 93.403 57.7202C95.4326 66.0279 97.078 67.6771 105.367 69.7114Z",
    fill: "#FEFEFE"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M484.564 117.838C479.272 119.136 478.221 120.189 476.925 125.493C475.63 120.189 474.579 119.136 469.287 117.838C474.579 116.539 475.63 115.486 476.925 110.182C478.221 115.486 479.272 116.539 484.564 117.838Z",
    fill: "#FEFEFE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M168.748 250.784C163.456 252.083 162.406 253.136 161.11 258.44C159.814 253.136 158.764 252.083 153.472 250.784C158.764 249.486 159.814 248.432 161.11 243.128C162.406 248.432 163.456 249.485 168.748 250.784Z",
    fill: "#FEFEFE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M126.038 150.591C120.746 151.89 119.696 152.943 118.4 158.247C117.104 152.943 116.054 151.89 110.762 150.591C116.054 149.293 117.104 148.24 118.4 142.936C119.696 148.24 120.746 149.293 126.038 150.591Z",
    fill: "#FEFEFE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7556 265.703C53.91 266.892 52.948 267.856 51.7616 272.713C50.5752 267.856 49.6132 266.892 44.7676 265.703C49.6132 264.514 50.5752 263.55 51.7616 258.693C52.948 263.549 53.91 264.514 58.7556 265.703Z",
    fill: "#FEFEFE"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M391.609 98.1148C388.93 98.7724 388.399 99.3055 387.743 101.99C387.087 99.3052 386.555 98.7724 383.876 98.1148C386.555 97.4572 387.087 96.9242 387.743 94.2393C388.399 96.9242 388.93 97.4572 391.609 98.1148Z",
    fill: "#FEFEFE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4423 221.731C78.7633 222.388 78.2317 222.921 77.5756 225.606C76.9195 222.921 76.3877 222.388 73.709 221.731C76.388 221.073 76.9195 220.54 77.5756 217.855C78.2314 220.54 78.7633 221.073 81.4423 221.731Z",
    fill: "#FEFEFE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M187.488 124.327C184.809 124.984 184.278 125.517 183.622 128.202C182.965 125.517 182.434 124.984 179.755 124.327C182.434 123.669 182.965 123.136 183.622 120.451C184.278 123.136 184.809 123.669 187.488 124.327Z",
    fill: "#FEFEFE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M623.598 270.95C615.309 272.984 613.664 274.633 611.634 282.941C609.605 274.633 607.959 272.984 599.671 270.95C607.959 268.915 609.605 267.266 611.634 258.958C613.664 267.266 615.31 268.915 623.598 270.95Z",
    fill: "#FEFEFE"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M555.184 136.318C546.895 138.353 545.25 140.002 543.22 148.309C541.191 140.002 539.545 138.353 531.257 136.318C539.545 134.284 541.191 132.635 543.22 124.327C545.25 132.635 546.895 134.284 555.184 136.318Z",
    fill: "#FEFEFE"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M522.871 284.983C517.579 286.282 516.529 287.335 515.233 292.639C513.937 287.335 512.887 286.282 507.595 284.983C512.887 283.684 513.937 282.631 515.233 277.327C516.529 282.631 517.579 283.684 522.871 284.983Z",
    fill: "#FEFEFE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7084 187.431C66.5273 189.193 65.1018 190.622 63.3435 197.82C61.5851 190.622 60.1593 189.193 52.9785 187.431C60.1593 185.668 61.5851 184.239 63.3435 177.042C65.1018 184.239 66.5276 185.668 73.7084 187.431Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundImage);
export default __webpack_public_path__ + "static/media/not-found-image.1a728c2bc1432f3e664f5bb48d48ac8b.svg";
export { ForwardRef as ReactComponent };